export const mapStatus = {
  COMPLETED: "Finalizado",
  PROGRESS: "Em progresso",
  FAILED: "Erro",
  CREATED: "Criado",
  CANCELLED: "Cancelado",
}

export const mapTipo = {
  atual: "Personalizado",
  historico: "Portador",
  empresa: "Empresa",
  fabrica: "Fábrica",
  custodia: "Custódia",
  bi: "BI",
  prevencao: "Prevenção",
  chamados: "Chamados",
}

export const tiposArquivo = [
  "atual",
  "historico",
  "empresa",
  "fabrica",
  "custodia",
  "bi",
  "prevencao",
  "chamados",
]

export const mapColor = {
  atual: "primary",
  historico: "secondary",
  empresa: "success",
  fabrica: "info",
  custodia: "warning",
  bi: "danger",
}
